(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rLoginWalletConnect2Provider", [], factory);
	else if(typeof exports === 'object')
		exports["rLoginWalletConnect2Provider"] = factory();
	else
		root["rLoginWalletConnect2Provider"] = factory();
})(this, function() {
return 